import React from "react";

import "./TableTolltip.scss";

const TableTooltip = ({ value, valueFormatted }) => {
  let cellValue;
  if (valueFormatted || valueFormatted === 0) {
    cellValue = valueFormatted;
  } else if (value && typeof value === "object") {
    cellValue = value.value;
  } else {
    cellValue = value;
  }
  return <span className="table-tooltip">{cellValue}</span>;
};

export default TableTooltip;
